import { Lock } from "lucide-react";

export interface LockedColumnRowProps {
  label: string;
}

export const LockedColumnRow = ({ label }: LockedColumnRowProps) => (
  <div className="flex items-center gap-2 rounded-md border bg-muted/40 px-2 py-1.5">
    <Lock className="h-4 w-4 text-muted-foreground" />
    <span className="flex-1 text-sm font-normal text-muted-foreground">{label}</span>
  </div>
);
